import { render, staticRenderFns } from "./DelegatePackages.vue?vue&type=template&id=6b3003de"
import script from "./DelegatePackages.vue?vue&type=script&lang=js"
export * from "./DelegatePackages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports